// Add project specific javascript code here:
import {ckeditorConfigRegistry} from 'sulu-admin-bundle/containers';
import {translate} from 'sulu-admin-bundle/utils';

ckeditorConfigRegistry.add((config) => ({
    heading: {
        options: [
            { model: 'paragraphSmall', view: { name: 'p', classes: 'text--sm' }, title: translate('sulu_admin.paragraph_small'), class: 'ck-heading_paragraph_small', converterPriority: 'high' },
            { model: 'paragraph', view: { name: 'p', classes: '' }, title: translate('sulu_admin.paragraph'), class: 'ck-heading_paragraph' },
            { model: 'paragraphLarge', view: { name: 'p', classes: 'text--lg' }, title: translate('sulu_admin.paragraph_large'), class: 'ck-heading_paragraph_large', converterPriority: 'high' },
            { model: 'heading1', view: { name: 'h1', classes: '' }, title: translate('sulu_admin.heading1'), class: 'ck-heading_heading1' },
            { model: 'heading2', view: { name: 'h2', classes: '' }, title: translate('sulu_admin.heading2'), class: 'ck-heading_heading2' },
            { model: 'heading3', view: { name: 'h3', classes: '' }, title: translate('sulu_admin.heading3'), class: 'ck-heading_heading3' },
            { model: 'heading4', view: { name: 'h4', classes: '' }, title: translate('sulu_admin.heading4'), class: 'ck-heading_heading4' },
            { model: 'heading5', view: { name: 'h5', classes: '' }, title: translate('sulu_admin.heading5'), class: 'ck-heading_heading5' },
            { model: 'heading6', view: { name: 'h6', classes: '' }, title: translate('sulu_admin.heading6'), class: 'ck-heading_heading6' }
        ]
    }
}));

function addBaseManagerListener() {
    window.setTimeout(
        function(){
            let baseManager = document.querySelector('button span[aria-label=su-list-ul]');

            if (baseManager != null) {
                baseManager = baseManager.parentElement;
                baseManager.onclick =  function() { window.location.href = '/admin/db-translations/list/messages/nl'; }
            } else {
                addBaseManagerListener();
            }
        },
        500);
}
addBaseManagerListener();
